<template>
    <layout>
        <rdkm-title>
            {{ $t('Услуги') }}
            <router-link tag="span" to="/services/add">
                <b-button class="float-right" right size="sm" variant="primary">
                    <font-awesome-icon icon="plus" /> {{ $t('Добавить') }}
                </b-button>
            </router-link>
        </rdkm-title>
        <div class="tile">     
            <filter-form :isActive="query.isActive" 
                        :name="query.name" 
                        :section="query.section" 
                        v-on:search="$refs.grid.filter($event, true)">
            </filter-form>       
            <rdkm-grid ref="grid" :state="query">
                <grid-column name="code" cell="edit-cell" :title="$t('Код')" width="120"></grid-column>
                <grid-column name="name" :title="$t('Название услуги')"></grid-column>
                <grid-column name="section" :title="$t('Раздел услуги')"></grid-column>
                <grid-column name="active" :title="$t('Действующая')"></grid-column>
                <grid-column name="createDate" :title="$t('Дата создания')" :format="date => moment(date).format('DD.MM.YYYY HH:mm')"></grid-column>                
                <grid-column name="price" :title="$t('Цена услуги, руб')"></grid-column>                
                <grid-column name="currency" :title="$t('Код валюты')"></grid-column>                
                <grid-column name="DELETE" cell="delete-cell"></grid-column>              
            </rdkm-grid>
        </div>
    </layout>
</template>

<script>
import FilterForm from "./Filter.vue";
import Grid from "../../components/grid/Grid.vue";
import GridColumn from "../../components/grid/GridColumn.vue";

export default {
  name: "Services",
  props: ["query"],
  components: {
    "filter-form": FilterForm, 
    "rdkm-grid": Grid,
    "grid-column": GridColumn 
  }
};
</script>
